/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Patients.Web.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CreateIntakeQuizSessionPatientApiInContract,
  CreateIntakeQuizSessionPatientApiOutContract,
  ProblemDetails,
  SubmitIntakeQuizResponsePatientApiInContract,
  SubmitIntakeQuizResponsePatientApiOutContract
} from '../pwrdbyQuickMDPatientsWebApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Creates a new intake quiz session and returns the entry point question with its options.
The client must supply the session ID it already uses for tracking.
 */
export const postIntakeQuizSessions = (
    createIntakeQuizSessionPatientApiInContract: CreateIntakeQuizSessionPatientApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<CreateIntakeQuizSessionPatientApiOutContract>(
      {url: `https://patient-web-api.api.quick.md/api/v1/intake-quiz/sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createIntakeQuizSessionPatientApiInContract, signal
    },
      options);
    }
  


export const getPostIntakeQuizSessionsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntakeQuizSessions>>, TError,{data: CreateIntakeQuizSessionPatientApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntakeQuizSessions>>, TError,{data: CreateIntakeQuizSessionPatientApiInContract}, TContext> => {

const mutationKey = ['postIntakeQuizSessions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntakeQuizSessions>>, {data: CreateIntakeQuizSessionPatientApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postIntakeQuizSessions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntakeQuizSessionsMutationResult = NonNullable<Awaited<ReturnType<typeof postIntakeQuizSessions>>>
    export type PostIntakeQuizSessionsMutationBody = CreateIntakeQuizSessionPatientApiInContract
    export type PostIntakeQuizSessionsMutationError = void

    /**
 * @summary Creates a new intake quiz session and returns the entry point question with its options.
The client must supply the session ID it already uses for tracking.
 */
export const usePostIntakeQuizSessions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntakeQuizSessions>>, TError,{data: CreateIntakeQuizSessionPatientApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntakeQuizSessions>>,
        TError,
        {data: CreateIntakeQuizSessionPatientApiInContract},
        TContext
      > => {

      const mutationOptions = getPostIntakeQuizSessionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Submits a response to a question in the specified intake quiz session.
Applies back-button pruning when overwriting an existing answer.
Returns the next question or signals the end of the flow.
 */
export const postIntakeQuizSessionsIdResponses = (
    id: string,
    submitIntakeQuizResponsePatientApiInContract: SubmitIntakeQuizResponsePatientApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<SubmitIntakeQuizResponsePatientApiOutContract>(
      {url: `https://patient-web-api.api.quick.md/api/v1/intake-quiz/sessions/${encodeURIComponent(String(id))}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitIntakeQuizResponsePatientApiInContract, signal
    },
      options);
    }
  


export const getPostIntakeQuizSessionsIdResponsesMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntakeQuizSessionsIdResponses>>, TError,{id: string;data: SubmitIntakeQuizResponsePatientApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntakeQuizSessionsIdResponses>>, TError,{id: string;data: SubmitIntakeQuizResponsePatientApiInContract}, TContext> => {

const mutationKey = ['postIntakeQuizSessionsIdResponses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntakeQuizSessionsIdResponses>>, {id: string;data: SubmitIntakeQuizResponsePatientApiInContract}> = (props) => {
          const {id,data} = props ?? {};

          return  postIntakeQuizSessionsIdResponses(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntakeQuizSessionsIdResponsesMutationResult = NonNullable<Awaited<ReturnType<typeof postIntakeQuizSessionsIdResponses>>>
    export type PostIntakeQuizSessionsIdResponsesMutationBody = SubmitIntakeQuizResponsePatientApiInContract
    export type PostIntakeQuizSessionsIdResponsesMutationError = ProblemDetails | void

    /**
 * @summary Submits a response to a question in the specified intake quiz session.
Applies back-button pruning when overwriting an existing answer.
Returns the next question or signals the end of the flow.
 */
export const usePostIntakeQuizSessionsIdResponses = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntakeQuizSessionsIdResponses>>, TError,{id: string;data: SubmitIntakeQuizResponsePatientApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntakeQuizSessionsIdResponses>>,
        TError,
        {id: string;data: SubmitIntakeQuizResponsePatientApiInContract},
        TContext
      > => {

      const mutationOptions = getPostIntakeQuizSessionsIdResponsesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    